module.exports = __webpack_public_path__ + "img/webtoon-ex.d65c1a9.png";